<template>
  <div id="httpConn">
    <div style="display: grid;">
      <label v-for="(option, index) in options" :key="index">
        <input 
          type="checkbox" 
          :value="option.value" 
          :checked="selectedOption === option.value"
          @change="handleCheckboxChange(option.value)"
        />
        {{ (option.label) }}
      </label>
    </div>
  </div>
</template>

<script>
import connection from '../../store/connection';

export default {
  name: "http-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
      options: [
        { value: 1, label: 'GET' },
        { value: 2, label: 'POST' },
        { value: 3, label: 'PUT' },
        { value: 4, label: 'DELETE' }
      ],
      selectedOption: connection.http || null, // Ensure single selection
    };
  },

  methods: {
    handleCheckboxChange(value) {
      // Enforce single selection
      if (this.selectedOption === value) {
        this.selectedOption = null; // Allow deselection
      } else {
        this.selectedOption = value;
      }

      // Update the connection.http value
      this.connection.http = this.selectedOption;
      this.connection.url = "/nash/func"
    },
    reset() {},

prepareForSave() {}
  },
};
</script>

<style scoped lang="css">
/* Add your styles here */
</style>



// WEBPACK FOOTER //
// src/components/connection/HTTPConnection.vue